import { createContext, JSX, useContext } from "solid-js";
import { IAnalyticsService } from "~/services/analytics_service/IAnalyticsService";

const AnalyticsServiceContext = createContext<IAnalyticsService>();

export const AnalyticsServiceProvider = (props: {
  children: JSX.Element;
  analyticsService: IAnalyticsService;
}) => {
  return (
    <AnalyticsServiceContext.Provider value={props.analyticsService}>
      {props.children}
    </AnalyticsServiceContext.Provider>
  );
};

export const useAnalyticsService = () => {
  const context = useContext<IAnalyticsService | undefined>(
    AnalyticsServiceContext
  );
  if (!context) {
    throw new Error(
      "useAnalyticsService must be used within a AnalyticsServiceProvider"
    );
  }
  return context;
};
